import {game} from "../main";
import {changeTexture} from "./changeTexture";

export function makeImage(
  x: number,
  y: number,
  frame: string,
  anchor: number | [number] | [number, number],
  groupToAdd?: Phaser.Group,
): Phaser.Image {
  const image = game.make.image(x, y);
  changeTexture(image, frame);

  typeof anchor === "number" ?
    image.anchor.setTo(anchor) : image.anchor.setTo(anchor[0], anchor[1]);

  // null will no
  if (groupToAdd) {
    (groupToAdd.add || groupToAdd.addChild).call(groupToAdd, image);
  } else if (groupToAdd === undefined) {
    game.world.add(image);
  }

  return image;
}
